import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { ERROR_LEVEL } from 'saddlebag-logger';

export const getValidResult = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    logError({
      error,
      message: `${error.toString()} string: ${str}`,
      level: ERROR_LEVEL.ERROR,
      component: 'transformConductorCreativeToAdvert',
      stacktrace: error.stack || error.stacktrace,
    });
    return null;
  }
};

export const getPackagesAttributes = (
  packageAttributes: string | undefined,
  customAttributes: Array<string | undefined>,
) => {
  // We add custom attributes and selected predefined attributes to an array together
  const maximumAttributes = 4;
  return (
    [...(packageAttributes?.split(',') || []), ...customAttributes]
      // We can have a maximum of 4 attributes in an ad so we slice the array
      .filter((attribute): attribute is string => !!attribute)
      .slice(0, maximumAttributes)
  );
};
